// Pure config-generation helpers for the /install page. Extracted from
// Install.tsx so they can be unit-tested without React.

export interface InstallTargetServer {
  key: string;
  url: string;
}

interface StdioEntry {
  command: string;
  args: string[];
}
interface HttpEntry {
  type: "http";
  url: string;
}
interface UrlEntry {
  url: string;
}

const KEY_PREFIX = "bio-";

export function sanitizeKey(key: string): string {
  return `${KEY_PREFIX}${key.replace(/[^a-z0-9-]/gi, "-")}`;
}

export function generateClaudeDesktop(servers: InstallTargetServer[]): string {
  const entries: Record<string, StdioEntry> = {};
  for (const s of servers) {
    entries[sanitizeKey(s.key)] = {
      command: "npx",
      args: ["-y", "mcp-remote", s.url],
    };
  }
  return JSON.stringify({ mcpServers: entries }, null, 2);
}

export function generateClaudeCode(servers: InstallTargetServer[]): string {
  const entries: Record<string, HttpEntry> = {};
  for (const s of servers) {
    entries[sanitizeKey(s.key)] = { type: "http", url: s.url };
  }
  return JSON.stringify({ mcpServers: entries }, null, 2);
}

export function generateClaudeCodeCli(servers: InstallTargetServer[]): string {
  return servers
    .map(
      (s) => `claude mcp add --transport http ${sanitizeKey(s.key)} ${s.url}`,
    )
    .join("\n");
}

export function generateCursor(servers: InstallTargetServer[]): string {
  const entries: Record<string, UrlEntry> = {};
  for (const s of servers) {
    entries[sanitizeKey(s.key)] = { url: s.url };
  }
  return JSON.stringify({ mcpServers: entries }, null, 2);
}

export function generateVsCode(servers: InstallTargetServer[]): string {
  const entries: Record<string, HttpEntry> = {};
  for (const s of servers) {
    entries[sanitizeKey(s.key)] = { type: "http", url: s.url };
  }
  return JSON.stringify({ servers: entries }, null, 2);
}
